/* Component Dependencies */
var nearByDestinationTemplate = require('templates/nearByDestination.hbs');
var AriesComponent = require('libs/aries-component');
var $ = require('jquery');


AriesComponent.create({
  type: 'nearByDestination',
  template: {
    'nearByDestination': nearByDestinationTemplate,
  },
  bindEvents: function() { 
    var _self = this; 
  },
  submitOfferSearch: function(long) {
    $('.long').text(long);
  }
});